import styled from 'styled-components';
import { colorToVariable } from '../../componentsThemeMap.js';
import { Pressable } from '../../ui/Button.js';
import '../../ui/Div/index.js';
import { Text } from '../../ui/Text.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
function FooterColumn({
  column,
  foregroundSecondary = 'foregroundMuted',
  foreground = 'gray80'
}) {
  return /*#__PURE__*/jsx(Div, {
    flexDirection: "column",
    children: column.filter(group => group.links.length > 0).map(({
      category,
      links
    }, index) => /*#__PURE__*/jsxs(LinkGroup, {
      children: [/*#__PURE__*/jsx(Text, {
        variant: "headline",
        as: "p",
        color: foreground,
        children: category
      }), /*#__PURE__*/jsx(Div, {
        as: "ul",
        spacingBottom: 3,
        spacingTop: 1,
        flexDirection: "column",
        css: {
          listStyleType: 'none',
          paddingInline: 0,
          marginBlock: 0
        },
        children: links.filter(link => !!link.label && (!!link.url || !!link.onClick)).map(({
          label,
          url,
          onClick,
          target
        }, linkIndex) => {
          const content = /*#__PURE__*/jsx(Text, {
            variant: "body",
            as: "span",
            color: foregroundSecondary,
            css: {
              ':hover': {
                color: colorToVariable('primary')
              }
            },
            children: label
          });
          if (onClick) {
            return /*#__PURE__*/jsx(Text, {
              variant: "body",
              as: "li",
              spacingBottom: 0.5,
              children: /*#__PURE__*/jsx(Pressable, {
                onPress: onClick,
                noScaleOnPress: true,
                children: content
              })
            }, linkIndex);
          }
          return /*#__PURE__*/jsx(Text, {
            variant: "body",
            as: "li",
            spacingBottom: 0.5,
            children: /*#__PURE__*/jsx(Pressable, {
              rel: target === '_blank' ? 'noopener noreferrer' : undefined,
              as: "a",
              href: url,
              target: target,
              children: content
            })
          }, linkIndex);
        })
      })]
    }, index))
  });
}
const LinkGroup = styled.div`
  display: inline-block;
  width: 100%;
`;
export { FooterColumn };
//# sourceMappingURL=FooterColumn.js.map
